// @flow
import styled from "styled-components";
import { fontNormal, fontMedium } from "../../_static/Typography";
import { buildText } from "../../_atom/Text";

import buildColor from "../../_static/ColorPalette";
import { buildTitle } from "../../_atom/Title";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TitleElement = styled(
  buildTitle({
    tag: "h4",
    uppercase: false,
    color: buildColor("grey", "900"),
    ellipsis: true
  })
)`
  font-family: ${fontMedium};
  font-style: normal;
  font-weight: 500;
  line-height: 19px;
`;

export const Separator = styled.div`
  &::before {
    margin: 12px -12px 16px 0;
    content: " ";
    display: block;
    border-bottom: 1px solid ${buildColor("blue", "100")};
  }
`;

export const Description = styled(
  buildText({
    tag: "div",
    fontSize: 14,
    color: buildColor("grey", "800")
  })
)`
  margin-top: 6px;

  & * {
    font-family: ${fontNormal};
    line-height: 18px;
  }

  & ol,
  ul {
    margin-top: 8px;
  }

  & li {
    margin-left: 16px;
    list-style-type: disc;
  }
`;
